import { useDispatch, useSelector } from "react-redux";
import { FC, useEffect, useState } from "react";
import { Input, Typography } from "antd";
import { useDebouncedCallback } from "use-debounce";

import { RootState } from "store/Reducers";
import { handleSetNewsFilter } from "../ClientSideStates";

const Search: FC<{ isUseLabel: boolean }> = ({ isUseLabel }) => {
  const { filter } = useSelector((state: RootState) => state.news);
  let dispatch = useDispatch();
  const {Text} = Typography
  const debounce = useDebouncedCallback((inputValue) => {
    let value = inputValue?.trim();
    if (value) {
      let newFilter = { ...filter };
      newFilter["Title"] = value;
      dispatch(handleSetNewsFilter({ filter: newFilter }));
    } else {
      let newFilter = { ...filter };
      delete newFilter["Title"];
      dispatch(handleSetNewsFilter({ filter: newFilter }));
    }
  }, 1000);
  let [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (filter) {
      setSearchValue(filter[`Title`]);
    }
  }, [filter]);

  return (
    <>
      <div className="!flex !flex-col justify-center ">
        {isUseLabel ? (
          <>
            <div className="!my-3" >
              <Text className="!font-bold" >Başlık</Text>
            </div>
          </>
        ) : (
          <></>
        )}

        <Input
          allowClear
          className="! !border-1  !w-full"
          placeholder={"Ara..."}
          onChange={(e) => {
            setSearchValue(e.target.value);
            debounce(e.target.value);
          }}
          value={searchValue}
        />
      </div>
    </>
  );
};

export default Search;
